import { useContext, useEffect, useState } from 'react';
import { AppMainStateContext } from '../../../../contexts/AppMainStateContext.tsx';
import { useAppDispatch, useAppSelector } from '../../../../stores/store.ts';
import { modalsStateActions } from '../../../popups/modalsStateSlice.ts';
import { IChannel } from '../../../../interfaces/IChannel.ts';
import { epgDetailsActions } from '../../../epg/EpgDetailsModal/epgDetailsSlice.ts';
import AccountFavoriteDetails from '../AccountFavoriteDetails.tsx';
import { ISearchEpg } from '../../../../interfaces/ISearchEpg.ts';
import apiNet from '../../../../newApi/apiNet.ts';
import { IFavorite } from '../../../../interfaces/account/favorite/IFavorite.ts';
import { PulseLoader } from '../../../loaders/PulseLoader.tsx';

interface IProps {
    channels: IChannel[],
    favorite: IFavorite
}

const AccountFavoriteDetailsModalContent = ({ favorite }: IProps) => {
    const [favoriteDetail, setFavoriteDetail] = useState<ISearchEpg | null>(null);
    const [isLoading, setIsLoading] = useState(true);
    const [error, setError] = useState<string | null>(null);

    useEffect(() => {
        setIsLoading(true);
        setError(null);

        apiNet.getEpgSearchResults(favorite.searchQuery)
            .then(res => res.data)
            .then(data => {
                setFavoriteDetail(data?.[0] || null);
            })
            .catch(err => {
                console.error(err);
                setError('Nie udało się pobrać danych');
            })
            .finally(() => setIsLoading(false));
    }, [favorite.searchQuery]);

    if (isLoading) return <PulseLoader />;
    if (error) return <div className="text-red-400 p-4">{error}</div>;
    if (!favoriteDetail) return <div>Brak danych</div>;

    return <AccountFavoriteDetails favoriteDetails={favoriteDetail} />;
};

const AccountFavoriteDetailsModal = ({ name, channels }: IProps) => {
    const { closeModal } = useContext(AppMainStateContext);
    const isOpen = useAppSelector(store => store.modalsState.isFavoriteDetailsModalOpen);
    const dispatch = useAppDispatch();
    const [favoriteDetail, setFavoriteDetail] = useState<ISearchEpg>();
    const [isLoading, setIsLoading] = useState(false);
    const handleCloseClick = () => {
        dispatch(modalsStateActions.setIsFavoriteDetailsModalOpen(false));
        closeModal();
    };
    useEffect(() => {
        const body = document.querySelector('body') as HTMLElement;
        if (isOpen)
            body.classList.add('overflow-hidden');
        else {
            body.classList.remove('overflow-hidden');
        }
    }, [isOpen]);

    useEffect(() => {
        return () => {
            const body = document.querySelector('body') as HTMLElement;
            body.classList.remove('overflow-hidden');
            dispatch(epgDetailsActions.setSelectedView('MAIN_VIEW'));
            dispatch(modalsStateActions.setIsFavoriteDetailsModalOpen(false));
        };
    }, []);

    useEffect(() => {
        setIsLoading(true);
        fetch('https://bmgodev.beskidmedia.pl/api/search?query=swiat+wedlug+kiepskich')
            .then(res => res.json())
            // .then(value => console.log(value[0]))
            .then(data => setFavoriteDetail(data[0]))
            .finally(() => setIsLoading(false));
    }, []);

    return (
        <div
            className={`${isOpen ? 'fixed' : 'hidden'}  top-0 left-0 w-screen h-screen z-60 animate-opacityEaseIn`}>
            <div className={'relative w-full h-full flex'}>
                <div
                    className={'bg-neutral-900/50 absolute top-0 left-0 w-full h-full z-0'}
                    onClick={handleCloseClick}
                />
                <div
                    className={'relative md:max-w-2xl md:max-h-[75%] z-10 w-full h-full top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 p-1'}>
                    {isOpen &&
                        <AccountFavoriteDetails name={name} favoriteDetails={favoriteDetail} />}
                </div>
            </div>
        </div>
    );
};

export default AccountFavoriteDetailsModalContent;